import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
const menuItems = [{
  id: 7,
  name: 'Gourmet Cinnamon Rolls',
  category: 'Dessert',
  diet: ['Halal'],
  price: '$12',
  image: 'https://cdn.magicpatterns.com/uploads/1mtjBM7PGqEFbAcR1KfPWN/Cinnamon_Rolls.png'
}, {
  id: 8,
  name: 'Jollof Rice & Blackened Salmon',
  category: 'Main',
  diet: ['Halal', 'Gluten-Free'],
  price: '$26',
  image: 'https://cdn.magicpatterns.com/uploads/f3VWVSaKQY5wcFvsJyJqUk/Jollof_Rice__Blackened_Salmon.png'
}, {
  id: 9,
  name: 'Jollof Rice & Jerk Wings',
  category: 'Main',
  diet: ['Halal'],
  price: '$22',
  image: 'https://cdn.magicpatterns.com/uploads/baJpov1KDY1ftKyWA3Hg5M/Jollof_Rice__Jerk_Wings.png'
}, {
  id: 10,
  name: 'Plantain',
  category: 'Side',
  diet: ['Vegan', 'Gluten-Free'],
  price: '$7',
  image: 'https://cdn.magicpatterns.com/uploads/oftURB1XDTBzJbEzrYpDix/Plantain.png'
}, {
  id: 11,
  name: 'Ademe',
  category: 'Main',
  diet: ['Gluten-Free'],
  price: '$18',
  image: 'https://cdn.magicpatterns.com/uploads/6ncPV6R1ANcmE2n55oxhJ5/Ademe.png'
}, {
  id: 12,
  name: 'Bitter Leaves Soup',
  category: 'Main',
  diet: ['Gluten-Free'],
  price: '$20',
  image: 'https://cdn.magicpatterns.com/uploads/uEDZQw1owAm4e7tBrzp67g/Bitter_Leaves_Soup.png'
}, {
  id: 13,
  name: 'Signature Jerk Wings',
  category: 'Appetizer',
  diet: ['Halal'],
  price: '$16',
  image: 'https://cdn.magicpatterns.com/uploads/462DUabUboVUaScUi2TTp8/image.png'
}, {
  id: 14,
  name: 'Jerk Wings & Creamy Pasta',
  category: 'Main',
  diet: ['Halal'],
  price: '$24',
  image: 'https://cdn.magicpatterns.com/uploads/wsgMXg5XYSsKVCAzFWXNDG/image.png'
}, {
  id: 15,
  name: 'Blackened Salmon & Creamy Pasta',
  category: 'Main',
  diet: ['Halal'],
  price: '$28',
  image: 'https://cdn.magicpatterns.com/uploads/esrZhHhi5YRSXkzA2yBcvc/image.png'
}];
const filters = ['All', 'Vegan', 'Gluten-Free', 'Halal'];
const fullMenu = {
  Starters: ['House Salad', 'Caesar Salad', 'Southwest Salad', 'Mac n Cheese Bites', 'Cajun Corn Bites', 'Crispy Chicken Sliders', 'Meat Pies', 'Suya Skewers', 'Mediterranean Chicken Skewers', 'Charcuterie Cups', 'Sweet Chili Shrimp', 'Stuffed Shrimp', 'Shrimp Cocktail', 'Bang Bang Shrimp', 'Crab Poppers', 'Creole Meatballs', 'Party Wings (Any Flavor)', 'Shrimp Tempura', 'Samosas (M) or (V)', 'Stuffed Mushrooms (V)', 'Deviled Eggs', 'Cheesy Bread', 'Bean Burger Sliders (V)', 'Ceviche (F)', 'Bruschetta', 'Pot Stickers (V)', 'Eggrolls (V)', 'Prosciutto Flatbread', 'Mini Beef Sliders', 'Crab Dip', 'Spinach Artichoke Dip', 'Mango Salsa Dip', 'Veggie Platter'],
  Entrees: ['Fried Chicken', 'Baked/Roasted Chicken', 'Jerk Chicken', 'Suya Chicken', 'Stuffed Chicken', 'Butter Chicken', 'Grilled Chicken', 'Chicken Stew', 'Honey Whiskey Glazed Wings', 'General Tso Chicken', 'Orange Chicken', 'Chicken & Broccoli', 'Turkey Wings', 'Chofi / Tsofi (Fried Turkey Tails)', 'Cauliflower Steak (V)', 'Fried Catfish', 'Lamb Chops', 'Lamb Suya', 'Ribeye Steak', 'Sirloin Steak', 'Filet Mignon', 'NY Strip Steak', 'Beef Suya', 'Mongolian Beef', 'Beef Stew', 'Flavored Salmon', 'Stuffed Salmon', 'Sautéed Creamy Shrimp', 'Grilled Shrimp', 'Tilapia', 'Cassava Leaves Stew', 'Egusi', 'Gboma Dessi', 'Oxtail', 'Oxtail Light Soup', 'Peanut Soup (Maafe)', 'Seafood Okra', 'Seafood Pasta', 'Lamb', 'Lump Crab Cake', 'Buttery Lobster Tail', 'Chicken/Steak/Shrimp Pasta', 'Peppered Goat Meat (Asun)', 'Braised Duck'],
  Sides: ['Fried Rice (West African or Asian)', 'Yellow Rice', 'White Rice', 'Jollof Rice', 'Attieke (Cassava Grains)', 'Garlic Butter Mash Potato', 'Scallop Potatoes', 'Sautéed Spinach', 'Sauteed Green Beans', 'Sautéed Asparagus', 'Smoked Collard Greens', 'Brussel Sprouts & Squash', 'Grilled Corn', 'Broccolini', 'Candied Yams', "Smackin' Mac & Cheese", 'Lobster Mac & Cheese', 'Fried Plantains', 'Alfredo Pasta', 'Couscous', 'Djenkoume', 'Jambalaya (Pasta)', 'Rasta Pasta', 'Lo Mein', 'Rice & Peas', 'Sweet Mashed Potatoes', 'Truffle Fries', 'Cheesy Naan Bread', 'Banku', 'Coleslaw', 'Caesar Salad', 'Chef Special Salad', 'Southwest Salad', 'Corn Chowder', 'French Onion Soup', 'One Pot Rice', 'Potato Wedges', 'Fried Yams', 'Pounded Yams', 'Ablo', 'Quinoa Lentil Salad'],
  Breakfast: ['Scrambled Eggs', 'Cheesy Scrambled Eggs', 'Egg Omelettes (Private Chef)', 'Turkey Bacon', 'Plant Based Sausage', 'Beef Bacon', 'Crab Cakes', 'Shrimp & Grits', 'Fried Catfish & Grits', 'Avocado Toast', 'Yogurt Parfait', 'Lox & Bagels', 'Breakfast Sandwich', 'Breakfast Wraps', 'Chicken & Waffle', 'Fried Wingettes', 'Apple Cinnamon French Toast', 'Cinnamon Rolls', 'Fruit Salad'],
  Beverages: ['Orange Juice', 'Apple Juice', 'Cranberry Juice', 'Grapefruit Juice', 'Iced Tea', 'Coffee', 'Hand-Crafted Mocktails', 'Mocktail Mimosas']
};
interface MenuExperienceProps {
  onSelectItem: (item: string) => void;
  isCompact?: boolean;
}
export function MenuExperience({
  onSelectItem,
  isCompact = false
}: MenuExperienceProps) {
  const [activeFilter, setActiveFilter] = useState('All');
  const filteredItems = activeFilter === 'All' ? menuItems : menuItems.filter(item => item.diet.includes(activeFilter));
  const displayItems = isCompact ? filteredItems.slice(0, 6) : filteredItems;
  return <section id="menu" className="py-16 md:py-20 bg-white" data-id="element-206">
      <div className="max-w-7xl mx-auto px-6" data-id="element-207">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-8" data-id="element-208">
          <div data-id="element-209">
            <h2 className="text-4xl md:text-5xl mb-4 font-serif text-brand-black" data-id="element-210">
              {isCompact ? 'Signature Dishes' : 'The Menu Experience'}
            </h2>
            <p className="text-gray-500 text-lg" data-id="element-211">
              Filter by dietary preference to find your perfect match.
            </p>
          </div>

          <div className="flex flex-wrap gap-3" data-id="element-212">
            {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 border ${activeFilter === filter ? 'bg-brand-black text-white border-brand-black' : 'bg-transparent text-gray-500 border-gray-200 hover:border-brand-gold'}`} data-id="element-213">
                {filter}
              </button>)}
          </div>
        </div>

        <motion.div layout className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-214">
          <AnimatePresence mode="popLayout" data-id="element-215">
            {displayItems.map(item => <motion.div key={item.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} className="group" data-id="element-216">
                <div className="relative aspect-square overflow-hidden rounded-sm mb-4 cursor-pointer" onClick={() => onSelectItem(item.name)} data-id="element-217">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-218" />
                  <div className="absolute inset-0 bg-brand-black/0 group-hover:bg-brand-black/20 transition-colors flex items-center justify-center" data-id="element-219">
                    <button className="bg-white text-brand-black px-4 py-2 text-xs font-bold uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0" data-id="element-220">
                      Add to Package
                    </button>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-white px-3 py-1 text-sm font-bold shadow-sm" data-id="element-221">
                    {item.price}
                  </div>
                </div>
                <div className="flex justify-between items-start" data-id="element-222">
                  <div data-id="element-223">
                    <h4 className="text-xl mb-1" data-id="element-224">{item.name}</h4>
                    <p className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-225">
                      {item.category}
                    </p>
                  </div>
                  <div className="flex gap-1" data-id="element-226">
                    {item.diet.map(d => <span key={d} className="w-2 h-2 rounded-full bg-brand-gold" title={d} data-id="element-227" />)}
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {isCompact ? <div className="mt-12 text-center" data-id="element-228">
            <Link to="/menu" className="bg-brand-black text-white px-10 py-5 rounded-sm text-sm font-bold uppercase tracking-widest hover:bg-brand-gold transition-all duration-300 shadow-xl inline-block" data-id="element-229">
              View Full Menu
            </Link>
          </div> : <div className="mt-20 pt-16 border-t border-gray-100" data-id="element-230">
            <div className="text-center mb-12" data-id="element-231">
              <h2 className="text-4xl md:text-5xl mb-4 font-serif text-brand-black" data-id="element-232">
                Complete Catering Menu
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-233">
                Explore our extensive selection of authentic dishes,
                customizable for any event size and dietary requirement.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 items-start" data-id="element-234">
              {Object.entries(fullMenu).map(([category, items]) => <div key={category} className="bg-gray-50 p-8 rounded-sm border border-gray-100" data-id="element-235">
                  <h3 className="text-2xl font-serif text-brand-gold mb-6 pb-4 border-b border-gray-200" data-id="element-236">
                    {category}
                  </h3>
                  <ul className="space-y-3" data-id="element-237">
                    {items.map((item, idx) => <li key={idx} className="text-sm text-gray-700 leading-relaxed flex items-start gap-2" data-id="element-238">
                        <span className="text-brand-gold mt-1" data-id="element-239">•</span>
                        <span data-id="element-240">{item}</span>
                      </li>)}
                  </ul>
                </div>)}
            </div>

            <div className="mt-16 text-center" data-id="element-241">
              <button onClick={() => onSelectItem('')} className="bg-brand-black text-white px-10 py-5 rounded-sm text-sm font-bold uppercase tracking-widest hover:bg-brand-gold transition-all duration-300 shadow-xl" data-id="element-242">
                Build Your Custom Menu
              </button>
            </div>

            <div className="mt-32 pt-24 border-t border-gray-100" data-id="element-243">
              <div className="text-center mb-12" data-id="element-244">
                <h3 className="text-3xl font-serif text-brand-black mb-4" data-id="element-245">
                  Package Reference Guide
                </h3>
                <p className="text-gray-500" data-id="element-246">
                  Quick reference for our catering styles and guest group tiers.
                </p>
              </div>
              <div className="max-w-5xl mx-auto" data-id="element-247">
                <img src="https://cdn.magicpatterns.com/uploads/oCxtfmG3XQ3rnHrEkVwDDY/Menu.png" alt="Pricing Guide" className="w-full h-auto rounded-sm shadow-lg" data-id="element-248" />
              </div>
            </div>
          </div>}
      </div>
    </section>;
}